module.exports = __webpack_public_path__ + "assets/icons/ic_more_vert_24px.svg";